const { useManagedFormController } = require('hooks/useFormPrimitives');
const useUserInputsFormConfig = require('./useUserInputsFormConfig');

const internals = {};

internals.buildRendererProps = ({
    defaultRendererProps,
    formState
}) => ({
    ...defaultRendererProps,
    shouldScrollToInterests: formState.locationStateActions.shouldScrollToInterests
});

module.exports = function useUserInputsController(props) {
    const formConfig = useUserInputsFormConfig(props);

    return useManagedFormController({
        buildRendererProps: internals.buildRendererProps,
        formConfig,
        props,
        formStateOptions: {
            title: 'UserInputs',
            formId: 'user-inputs',
            debug: {
                enabled: true,
                name: 'UserInputs'
            },
            defaultsDeps: [
                props.defaultInterestId,
                props.majors,
                props.signupDetails
            ],
            initialStateDeps: [
                props.initialState,
                props.location?.state,
                props.signupDetails
            ],
            syncDefaults: false
        }
    });
};

module.exports.internals = internals;
